const PEDEAI_APP = 7;

export default {
  PEDEAI_APP,
};
